import React from 'react';


import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';

import {DomainsSection} from './domains';
import {EzProxySection} from './ez-proxy';
import {IpRangesSection} from './ip-ranges';

import type {Error} from 'src/openapi/admin/models/Error';
import type {IpRange} from 'src/openapi/admin/models/IpRange';
import type {ProxyLink} from 'src/openapi/admin/models/ProxyLink';

type Props = {
    disabled?: boolean,

    ipRangesLoading: boolean,
    ipRangesLoadingError: Error | null,
    ipRanges: Array<IpRange>,
    setIpRanges: React.Dispatch<React.SetStateAction<Array<IpRange>>>,
    setLastEditedRange: (id: number) => void,

    domainsLoading: boolean,
    domainsLoadingError: Error | null,
    domains: Array<string>,
    busyDomains: Record<string, boolean>,
    setDomains: React.Dispatch<React.SetStateAction<Array<string>>>,
    setLastEditedDomain: (id: number) => void,

    proxyLoading: boolean,
    proxyLoadingError: Error | null,
    proxy: ProxyLink,
    setProxy: (proxy: ProxyLink) => void,
    onFieldChange: (parameterName: string) => void,
};

export const AccessControlsSection: React.FC<Props> = ({
    disabled,

    ipRangesLoading,
    ipRangesLoadingError,
    ipRanges,
    setIpRanges,
    setLastEditedRange,

    domainsLoading,
    domainsLoadingError,
    domains,
    busyDomains,
    setDomains,
    setLastEditedDomain,

    proxyLoading,
    proxyLoadingError,
    proxy,
    setProxy,
    onFieldChange,
}) => (
    <FormSection
        headline="Account Access Controls"
        info={headline => (ipRangesLoading ? <SkeletonItem width={240} height={28}/> : headline)}>
        <Group direction="v" alignItems="start">
            <IpRangesSection
                disabled={disabled}
                isLoading={ipRangesLoading}
                loadingError={ipRangesLoadingError}
                ipRanges={ipRanges}
                onChange={data => {
                    onFieldChange('IP Ranges');
                    return setIpRanges(data);
                }}
                setLastEditedRange={setLastEditedRange}
            />
            <DomainsSection
                readonly={disabled}
                busyDomains={busyDomains}
                isLoading={domainsLoading}
                loadingError={domainsLoadingError}
                domains={domains}
                onChange={data => {
                    onFieldChange('Domains');
                    return setDomains(data);
                }}
                setLastEditedDomain={setLastEditedDomain}
            />
            <EzProxySection
                disabled={disabled}
                isLoading={proxyLoading}
                loadingError={proxyLoadingError}
                proxy={proxy}
                onChange={data => {
                    onFieldChange('EZProxy URL');
                    return setProxy(data);
                }}
            />
        </Group>
    </FormSection>
);
